export default {"src":"/_next/static/media/playBtn.cf4272b8.svg","height":7,"width":6,"blurWidth":0,"blurHeight":0};